import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { renderInput, required } from './formHelper';

class View extends Component {
  getGradeList() {
    const { schoolName, gradeList } = this.props;
    if (schoolName === '') {
      return gradeList;
    }

    if (schoolName.includes('中等教育学校') || ((schoolName.includes('中学') || schoolName.includes('中等') || schoolName.includes('中・'))
        && schoolName.includes('高等'))) {
      return gradeList;
    }

    if (schoolName.includes('中学校')
        || schoolName.includes('中等')) {
      return gradeList.filter((x) => x[1] >= 5 && x[1] <= 9);
    }

    if (schoolName.includes('高等学校')
        || schoolName.includes('高等専門学校')) {
      return gradeList.filter((x) => x[1] >= 10 && x[1] <= 12);
    }

    return gradeList;
  }

  render() {
    return (
      <Field
        id="student_grade"
        type="select"
        name={this.props.name}
        component={renderInput}
        validate={[required]}
      >
        <option value="">お選びください</option>
        {this.getGradeList().map((x) => <option key={x[1]} value={x[1]}>{x[0]}</option>)}
      </Field>
    );
  }
}

View.propTypes = {
  name: PropTypes.string.isRequired,
  schoolName: PropTypes.string.isRequired,
  gradeList: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]))).isRequired,
};

export default View;
